import React from "react";
import { Row, Col, Progress, Tabs } from "antd";
import NProgress from "nprogress";
import classnames from "classnames";
import "nprogress/nprogress.css";
import middleware from "../../middleware";

import RightMenu from "@RightMenu";

class WeaNewTopReq extends React.Component {
  static displayName = "WeaNewTopReq";
  static defaultProps = {
    dropMenuDatas: undefined,
    dropMenuProps: {},
    icon: "",
    iconBgcolor: "",
    title: "",
    buttons: [],
    buttonSpace: 0,
    selectedKey: [],
    tabDatas: [],
    replaceTab: "",
    className: "",
    style: {}
  };

  constructor(props) {
    super(props);
    this.instanceIsMounted = false;
    this.hash = `weareqtop_${Math.random()
      .toString(36)
      .substr(2, 6)}_${new Date().getTime()}`;
    this.state = {
      showDrop: this.props.showDrop || false,
      percent: 85,
      end: true,
      height: 0,
      showShadow: false,
      width: 0,
      leftMaxWidth: "auto",
      isDropMenuEmpty: false
    };
  }

  componentDidMount() {
    this.instanceIsMounted = true;
    this.scrollheigth();
    this.reGetWidth();
    this.resizeLeftWidth(); //进入的时候计算一次
    window.addEventListener("resize", this.onWindowResize);
    NProgress.configure({ showSpinner: false, minimum: 0.3, speed: 500 });
    this.props.onDidMount && this.props.onDidMount(this.props, this.hash);
    window.onTopDidMount && window.onTopDidMount(this.props, this.hash);
    if (this.RightMenu && this.RightMenu.isEmpty)
      this.setState({ isDropMenuEmpty: true });
  }

  componentWillReceiveProps(nextProps) {
    const { loading, heightSpace, buttons } = this.props;
    if (!loading && nextProps.loading) {
      NProgress.configure({ parent: `#${this.hash}` });
      NProgress.start(0.3);
      // this.timer = setInterval(() => {
      //   const percent = this.state.percent;
      //   const newP = percent < 96 ? (percent + 1) : 96;
      //   this.instanceIsMounted && this.setState({ end: false, percent: newP });
      // }, 10);
    } else if (loading && !nextProps.loading) {
      NProgress.done();
      // this.setState({ percent: 100 });
      // this.timer && clearInterval(this.timer);
      // setTimeout(() => {this.instanceIsMounted && this.setState({ percent: 85, end: true });}, 300);
    }
    if (heightSpace !== nextProps.heightSpace) {
      this.scrollheigth();
    }

    //得到buttons的时候重新计算
    if (nextProps.buttons && buttons.length !== nextProps.buttons.length) {
      setTimeout(() => this.resizeLeftWidth(), 200);
    }

    if (nextProps.showDrop !== this.state.showDrop) {
      this.setState({ showDrop: nextProps.showDrop });
    }
  }

  componentDidUpdate() {
    this.scrollheigth();
    const { isDropMenuEmpty } = this.state;
    const isdropmenuempty = this.RightMenu && this.RightMenu.isEmpty;
    if (isdropmenuempty !== isDropMenuEmpty)
      this.setState({ isDropMenuEmpty: isdropmenuempty });
  }

  componentWillUnmount() {
    // 防止节点卸载问题。。。
    window.removeEventListener("resize", this.onWindowResize);
    NProgress.configure({ parent: "body" });
    NProgress.done();
    NProgress.remove();
    this.instanceIsMounted = false;
  }

  onWindowResize = () => {
    if (this.instanceIsMounted) {
      this.scrollheigth();
      this.reGetWidth();
    }
    this.resizeLeftWidth(); //resize重新计算
  };
  resizeLeftWidth = () => {
    if (this.refs.right && this.refs.title) {
      const titleWidth = this.refs.title.clientWidth;
      const rightWidth = this.refs.right.clientWidth;
      this.setState({ leftMaxWidth: titleWidth - rightWidth });
    }
  };

  onChange(key) {
    if (typeof this.props.onChange === "function") {
      this.props.onChange(key);
    }
  }

  scrollheigth() {
    const { heightSpace } = this.props;
    const heightOther = heightSpace || 0;
    const content = this.refs.content;
    const top = $(content).offset()
      ? $(content).offset().top
        ? $(content).offset().top
        : 0
      : 0;
    const scrollheigth =
      document.documentElement.clientHeight - top - heightOther;
    const { height } = this.state;
    scrollheigth &&
      scrollheigth !== height &&
      this.setState({ height: scrollheigth });
  }

  reGetWidth() {
    const width = this.wapper.offsetWidth;
    width && this.setState({ width });
  }

  render() {
    const {
      showDrop,
      percent,
      height,
      end,
      showShadow,
      width: w,
      isDropMenuEmpty
    } = this.state;
    const {
      children,
      icon,
      iconBgcolor,
      title,
      buttons,
      buttonSpace,
      selectedKey,
      tabDatas,
      showDropIcon,
      dropMenuDatas,
      replaceTab,
      dropMenuProps,
      onDropMenuClick,
      className,
      style,
      handleDropMenuVisible
    } = this.props;
    const menuProps = { ...dropMenuProps };
    if (dropMenuProps.datas === undefined && Array.isArray(dropMenuDatas)) {
      menuProps.datas = dropMenuDatas;
    }
    if (typeof onDropMenuClick === "function") {
      menuProps.onClick = onDropMenuClick;
    }
    const isIE8 = window.navigator.appVersion.indexOf("MSIE 8.0") >= 0;
    const mainClx = classnames({
      "wea-new-top-req-main": true,
      "wea-new-top-req-main-shadow": showShadow
    });
    if (
      (!document.title || document.title === "undefined") &&
      typeof title === "string"
    ) {
      document.title = title;
    }
    return (
      <div
        className={`wea-new-top-req-wapper ${className}`}
        style={style}
        ref={c => (this.wapper = c)}
        id={this.hash}
      >
        <Row className="wea-new-top-req">
          {!end ? (
            <Progress
              percent={percent}
              showInfo={false}
              strokeWidth={2}
              status="active"
            />
          ) : (
            ""
          )}
          <Col className={mainClx} span={24}>
            <div className="wea-new-top-req-icon">
              {iconBgcolor ? (
                <div
                  className="icon-circle-base"
                  style={{ background: iconBgcolor || "" }}
                >
                  {icon}
                </div>
              ) : (
                <span style={{ verticalAlign: "middle", marginRight: 10 }}>
                  {icon}
                </span>
              )}
            </div>
            <div className="wea-new-top-req-title-text wea-f14">{title}</div>
            <div ref="title">
              <Row className="wea-new-top-req-title">
                <Col xs={isIE8 ? 10 : 6} sm={6} md={8} lg={10}>
                  <div
                    style={{
                      maxWidth: this.state.leftMaxWidth,
                      overflow: "hidden"
                    }}
                  >
                    {replaceTab ? (
                      <div style={{ paddingLeft: 8 }}>{replaceTab}</div>
                    ) : (
                      <Tabs
                        defaultActiveKey={selectedKey}
                        activeKey={selectedKey}
                        onChange={this.onChange.bind(this)}
                      >
                        {tabDatas &&
                          tabDatas.map(data => {
                            return (
                              <Tabs.TabPane tab={data.title} key={data.key} />
                            );
                          })}
                      </Tabs>
                    )}
                  </div>
                </Col>
                <Col
                  xs={isIE8 ? 14 : 18}
                  sm={18}
                  md={16}
                  lg={14}
                  style={{ textAlign: "right", marginTop: -5 }}
                >
                  <div ref="right">
                    {buttons.map(data => {
                      return (
                        <span
                          style={{
                            display: "inline-block",
                            lineHeight: "28px",
                            verticalAlign: "middle",
                            marginLeft: !!buttonSpace ? buttonSpace : 10
                          }}
                        >
                          {data}
                        </span>
                      );
                    })}
                    {showDropIcon && !isDropMenuEmpty && (
                      <span
                        className={`wea-new-top-req-drop-btn ${isDropMenuEmpty &&
                          "wea-new-top-drop-btn-displayNone"}`}
                        onClick={() =>
                          this.setState(
                            { showDrop: true },
                            () =>
                              typeof handleDropMenuVisible === "function" &&
                              handleDropMenuVisible(true)
                          )
                        }
                      >
                        <i className="icon-button icon-New-Flow-menu" />
                      </span>
                    )}
                    <div
                      className="wea-new-top-req-drop-menu wea-right-menu"
                      onMouseLeave={() =>
                        this.setState(
                          { showDrop: false },
                          () =>
                            typeof handleDropMenuVisible === "function" &&
                            handleDropMenuVisible(false)
                        )
                      }
                      style={{ display: showDrop ? "block" : "none" }}
                    >
                      <span
                        className="wea-new-top-req-drop-btn"
                        onClick={() =>
                          this.setState(
                            { showDrop: false },
                            () =>
                              typeof handleDropMenuVisible === "function" &&
                              handleDropMenuVisible(false)
                          )
                        }
                      >
                        <i className="icon-button icon-New-Flow-menu" />
                      </span>
                      {Object.keys(menuProps).length > 0 ? (
                        <RightMenu
                          {...menuProps}
                          ref={el => (this.RightMenu = el)}
                        />
                      ) : null}
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
        {children && (
          <div
            ref="content"
            className="wea-new-top-req-content"
            style={{ height }}
            onScroll={e => {
              if (e.target.scrollTop === 0) {
                this.setState({ showShadow: false });
              } else if (!showShadow) {
                this.setState({ showShadow: true });
              }
            }}
          >
            {children}
          </div>
        )}
      </div>
    );
  }
}

const Com = middleware(WeaNewTopReq, "WeaReqTop");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-req-top/index.js